/* My Elegant Horse – sivupaneelikori ja Osta nyt -suora kassalle */
(function () {
  var ADDON = { tarranauha: 1, aanieristys: 1 };
  var css = '' +
    '.mehd-bg{position:fixed;inset:0;z-index:2147482000;background:rgba(0,0,0,.45);opacity:0;transition:opacity .25s ease}' +
    '.mehd-bg.on{opacity:1}' +
    '.mehd{position:fixed;top:0;right:0;bottom:0;z-index:2147482001;width:min(420px,100%);background:#FFFFFF;color:#000000;display:flex;flex-direction:column;font-family:Jost,"Helvetica Neue",Arial,sans-serif;font-size:15px;line-height:1.5;transform:translateX(100%);transition:transform .28s ease;box-shadow:-12px 0 40px rgba(0,0,0,.18)}' +
    '.mehd.on{transform:none}' +
    '.mehd__h{display:flex;align-items:center;justify-content:space-between;padding:18px 20px;border-bottom:1px solid #EBEBEB}' +
    '.mehd__t{margin:0;font-family:"Bodoni Moda",Didot,Georgia,serif;font-weight:400;font-size:20px;letter-spacing:.06em;text-transform:uppercase}' +
    '.mehd__x{width:44px;height:44px;border:0;background:none;font-size:28px;line-height:1;cursor:pointer;color:#000000}' +
    '.mehd__ok{display:flex;gap:10px;align-items:center;padding:12px 20px;background:#F7F3EC;font-size:14px}' +
    '.mehd__ok i{flex:none;width:8px;height:8px;border-radius:50%;background:#4F7A4A}' +
    '.mehd__list{flex:1;overflow:auto;padding:4px 20px}' +
    '.mehd__it{display:flex;gap:14px;padding:16px 0;border-bottom:1px solid #EBEBEB}' +
    '.mehd__it img{flex:none;width:76px;height:76px;object-fit:contain;background:#F5F5F5}' +
    '.mehd__it b{display:block;font-weight:500;text-transform:none;letter-spacing:0}' +
    '.mehd__it small{display:block;color:#6B6B6B;font-size:13px}' +
    '.mehd__p{margin-left:auto;white-space:nowrap}' +
    '.mehd__add{display:flex;justify-content:space-between;gap:10px;font-size:13px;color:#444444;padding:2px 0 0}' +
    '.mehd__q{display:flex;align-items:center;gap:6px;margin-top:8px;font-size:14px}' +
    '.mehd__q button{width:32px;height:32px;border:1px solid #CCCCCC;background:#FFFFFF;color:#000000;font:inherit;font-size:17px;line-height:1;cursor:pointer;padding:0}' +
    '.mehd__q span{min-width:22px;text-align:center}' +
    '.mehd__q .mehd__rm{width:auto;border:0;background:none;text-decoration:underline;font-size:13px;color:#6B6B6B;margin-left:auto;padding:0 2px}' +
    '.mehd__q button:disabled{opacity:.4;cursor:default}' +
    '.mehd__tyhja{padding:28px 0;color:#6B6B6B}' +
    '.mehd__f{padding:18px 20px calc(18px + env(safe-area-inset-bottom,0px));border-top:1px solid #EBEBEB;display:flex;flex-direction:column;gap:10px}' +
    '.mehd__sum{display:flex;justify-content:space-between;font-size:17px}' +
    '.mehd__note{font-size:13px;color:#6B6B6B;margin-top:-6px}' +
    '.mehd__go{display:flex;align-items:center;justify-content:center;min-height:56px;background:#000000;color:#FFFFFF !important;text-decoration:none;font-weight:500;letter-spacing:.07em;text-transform:uppercase;border:0;font-size:15px;cursor:pointer}' +
    '.mehd__go:hover{background:#222222}' +
    '.mehd__row{display:flex;gap:10px}' +
    '.mehd__sec{flex:1;display:flex;align-items:center;justify-content:center;min-height:48px;border:1px solid #CCCCCC;background:#FFFFFF;color:#000000 !important;text-decoration:none;font:inherit;font-size:14px;cursor:pointer}' +
    '.mehd a:focus-visible,.mehd button:focus-visible{outline:2px solid #A16207;outline-offset:2px}' +
    '@media (prefers-reduced-motion: reduce){.mehd,.mehd-bg{transition:none}}';

  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function eur(c) { var v = (c / 100).toFixed(2).replace('.', ','); return v.replace(/,00$/, '') + ' €'; }
  function img(u) { if (!u) return ''; return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=200'; }

  var styled = false, last = null;
  function close() {
    var d = document.querySelector('.mehd'), b = document.querySelector('.mehd-bg');
    if (!d) return;
    d.classList.remove('on'); if (b) b.classList.remove('on');
    document.removeEventListener('keydown', onKey);
    document.body.style.overflow = '';
    setTimeout(function () { if (d) d.remove(); if (b) b.remove(); }, 300);
    if (last && last.focus) try { last.focus(); } catch (e) {}
  }
  function onKey(e) { if (e.key === 'Escape') close(); }

  function open(cart, muokattu) {
    if (!styled) { var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st); styled = true; }
    var old = document.querySelector('.mehd'); if (old) old.remove();
    var oldb = document.querySelector('.mehd-bg'); if (oldb) oldb.remove();
    last = document.activeElement;

    var rows = [], cur = null;
    (cart.items || []).forEach(function (it) {
      if (ADDON[it.handle] && cur) { cur.addons.push(it); return; }
      cur = { it: it, addons: [] }; rows.push(cur);
    });
    var list = rows.map(function (r, ri) {
      var it = r.it, props = it.properties || {}, extra = '';
      if (props['Mitat']) extra += '<small>Omat mitat: ' + esc(props['Mitat']) + '</small>';
      var adds = r.addons.map(function (a) {
        var n = a.handle === 'tarranauha' ? 'Tarranauhat' : 'Äänieristys ' + esc(a.variant_title || '');
        return '<div class="mehd__add"><span>+ ' + n + '</span><span>' + eur(a.final_line_price) + '</span></div>';
      }).join('');
      var vt = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + (it.quantity > 1 ? ' · ' + it.quantity + ' kpl' : '') + '</small>' : (it.quantity > 1 ? '<small>' + it.quantity + ' kpl</small>' : '');
      return '<div class="mehd__it">' + (it.image ? '<img src="' + esc(img(it.image)) + '" alt="">' : '') +
        '<div style="flex:1;min-width:0"><div style="display:flex;gap:10px"><b>' + esc(it.product_title) + '</b><span class="mehd__p">' + eur(it.final_line_price) + '</span></div>' + vt + extra + adds +
        '<div class="mehd__q" data-rivi="' + ri + '"><button type="button" data-q="-1" aria-label="Vähennä määrää"' + (it.quantity <= 1 ? ' disabled' : '') + '>−</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-q="1" aria-label="Lisää määrää">+</button><button type="button" class="mehd__rm" data-rm>Poista</button></div></div></div>';
    }).join('') || '<p class="mehd__tyhja">Ostoskori on tyhjä.</p>';

    var bg = document.createElement('div'); bg.className = 'mehd-bg';
    var d = document.createElement('div'); d.className = 'mehd';
    d.setAttribute('role', 'dialog'); d.setAttribute('aria-modal', 'true'); d.setAttribute('aria-labelledby', 'mehd-t');
    d.innerHTML =
      '<div class="mehd__h"><h2 class="mehd__t" id="mehd-t">Ostoskori</h2><button type="button" class="mehd__x" aria-label="Sulje ostoskori">×</button></div>' +
      (muokattu ? '' : '<div class="mehd__ok" role="status"><i aria-hidden="true"></i>Korvahuppu lisätty ostoskoriin</div>') +
      '<div class="mehd__list">' + list + '</div>' +
      '<div class="mehd__f">' +
        '<div class="mehd__sum"><span>Yhteensä</span><span>' + eur(cart.total_price) + '</span></div>' +
        '<div class="mehd__note">Ilmainen toimitus · hinnat sisältävät ALV:n</div>' +
        '<a class="mehd__go" href="/checkout">Siirry kassalle</a>' +
        '<div class="mehd__row"><button type="button" class="mehd__sec" data-close>Jatka ostoksia</button><a class="mehd__sec" href="/cart">Katso ostoskori</a></div>' +
      '</div>';
    document.body.appendChild(bg); document.body.appendChild(d);
    bg.addEventListener('click', close);
    d.querySelector('.mehd__x').addEventListener('click', close);
    d.querySelector('[data-close]').addEventListener('click', close);
    // Määrän muutos ja poisto: korvahupun lisäosat (äänieristys, tarranauhat) muuttuvat samassa suhteessa
    d.querySelector('.mehd__list').addEventListener('click', function (e) {
      var b = e.target.closest('button'), q = b && b.closest('.mehd__q');
      if (!q) return;
      var r = rows[Number(q.getAttribute('data-rivi'))], uusi = b.hasAttribute('data-rm') ? 0 : Math.max(1, r.it.quantity + Number(b.getAttribute('data-q')));
      if (uusi === r.it.quantity) return;
      var updates = {}; updates[r.it.key] = uusi;
      r.addons.forEach(function (a) { updates[a.key] = Math.round(a.quantity / r.it.quantity * uusi); });
      q.querySelectorAll('button').forEach(function (x) { x.disabled = true; });
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function (res) { return res.json(); })
        .then(function (c) { if (window.MEH_CART) window.MEH_CART(c.item_count); muuta(c); })
        .catch(function () { q.querySelectorAll('button').forEach(function (x) { x.disabled = false; }); });
    });
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    if (muokattu) { bg.classList.add('on'); d.classList.add('on'); }
    else requestAnimationFrame(function () { bg.classList.add('on'); d.classList.add('on'); d.querySelector('.mehd__go').focus(); });
  }
  // Uudelleenpiirto muutoksen jälkeen ilman avausanimaatiota; kohdistus pysyy korissa
  function muuta(c) { var keep = last; open(c, true); last = keep; var dd = document.querySelector('.mehd'); if (dd) (dd.querySelector('.mehd__q button:not([disabled])') || dd.querySelector('.mehd__x')).focus(); }
  window.MEH_DRAWER = function () { return fetch('/cart.js').then(function (r) { return r.json(); }).then(open); };

  document.addEventListener('DOMContentLoaded', function () {
    var add = window.MEH_ADD;
    if (typeof add !== 'function') return;
    window.MEH_ADD = function (o) {
      var buy = !!(o && o.buyNow);
      return add.apply(this, arguments).then(function (n) {
        if (buy) { window.location.href = '/checkout'; return n; }
        try { window.MEH_DRAWER().catch(function () {}); } catch (e) {}
        return n;
      });
    };
  });
})();
